import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription, filter } from 'rxjs';

import { ButtonTypesEnum } from '../../../../Forms/enums/button-types.enum';
import { CurrentUserStateService } from '../../../../../Core/Users/services/current-user-state.service';
import { DataPointModel } from '../../../../Charts/models/data-point.model';
import { PreferencesModel } from '../../../../../Core/Users/models/preferences.model';
import { TimeZoneFormatEnum } from '../../../../Misc/enums/time-zone-format.enum';
import { AlertSurgeMetricEnum } from '../../../../../Monitor/Alerts/enums/alert-surge-metric.enum';

@Component({
    selector: 'agpr-list-detail-card',
    templateUrl: './list-detail-card.component.html',
    styleUrls: ['./list-detail-card.component.scss'],
    standalone: false
})
export class ListDetailCardComponent  implements OnInit, OnDestroy {

    @Input() data: DataPointModel;
    @Input() id: string;
    @Input() small: boolean = false;

    preferences: PreferencesModel;
    subscriptions: Subscription[] = [];
    tooltipText: string;
    ariaLabelText: string;
    readonly shortTimeFormat = TimeZoneFormatEnum.shortTimeZoneFormat;
    readonly longTimeFormat = TimeZoneFormatEnum.longTimeZoneFormat;
    readonly buttonTypes = ButtonTypesEnum;
    readonly alertSurgeMetrics = AlertSurgeMetricEnum;

    constructor (
        private currentUserStateService: CurrentUserStateService,
        private router: Router
    ) {

    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.currentUserStateService.getPreferences().pipe(filter(x => !!x)).subscribe(prefs =>
                this.preferences = prefs
            )
        );
        this.tooltipText =  this.formatTooltip(this.data.tooltipInfo);
        this.ariaLabelText = this.formatTooltip(this.data.tooltipHtml);
    }

    stripHtml(html: string): string {
        const div = document.createElement('div');
        div.innerHTML = html;
        return div.textContent || div.innerText || '';
    }

    formatTooltip(info: any): string {
        if (typeof info === 'string') {
            return info;
        } else if (typeof info === 'number') {
            return info.toString();
        } else if (typeof info === 'object' && info !== null) {
            return JSON.stringify(info);
        }
        return '';
    }

    onMouseEnter() {
        this.tooltipText = this.formatTooltip(this.data.tooltipHtml);
        this.ariaLabelText = this.stripHtml(this.tooltipText);
    }

    onMouseLeave() {
        this.tooltipText = this.formatTooltip(this.data.tooltipInfo);
        this.ariaLabelText = this.tooltipText;
    }

    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    navigateToRoute(): void {
        if (this.data.route) {
            this.router.navigate([this.data.route]);
        }
    }
}
